import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import TheSignatureLook from "./sections/TheSignatureLook";
import EditorialExcellence from "./sections/EditorialExcellence";
import CoreArtistryServices from "./sections/CoreArtistryServices";
import SecureYourSession from "./sections/SecureYourSession";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <TheSignatureLook />
      <EditorialExcellence />
      <CoreArtistryServices />
      <SecureYourSession />
      <SiteFooter />
    </div>;
}